import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-jasmeen',
  templateUrl: './jasmeen.component.html',
  styleUrls: ['./jasmeen.component.scss']
})
export class JasmeenComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getJasmeen();
  }

}
